export const createRequestBody = (values, issuerCode, id) => {
    let requestObject;
    if (id) {
        requestObject = {
            ...values,
            autoUploadPerso: true,
            requestType: "NEW",
            cardType: "PREPAID",
            issuerCode: issuerCode,
            // defaultPinValue: values && values.defaultPinValue ? values.defaultPinValue : "0000",
        };
    } else {
        if (values) {
            requestObject = {
                name: values && values.name ? values.name : "",
                description: values && values.description ? values.description : "",
                autoUploadPerso: true,
                cardProfileCode: values && values.cardProfileCode.name ? values.cardProfileCode.name : "",
                cardProgram: values && values.cardProgram.name ? values.cardProgram.name : "",
                cardScheme: values && values.cardScheme.value ? values.cardScheme.value : "",
                emvProfileCode: values && values.emvProfileCode.name ? values.emvProfileCode.name : "",
                persoCode: values && values.persoCode.persoCode ? values.persoCode.persoCode : "",
                persoFormatCode: values && values.persoFormatCode.name ? values.persoFormatCode.name : "",
                pinGenerationMethod: values && values.pinGenerationMethod.value ? values.pinGenerationMethod.value : "",
                // requestType:
                //   values && values.requestType.type ? values.requestType.type : "",
                // scpCardProgram:
                //   values && values.scpCardProgram.name ? values.scpCardProgram.name : "",
                cardType: "PREPAID",
                issuerCode: issuerCode,
                defaultPinValue: values && values.defaultPinValue ? values.defaultPinValue : "0000",
            };
        }
    }

   
    return requestObject;
};
